import { Component } from '@angular/core';

@Component({
    selector: 'loading-comp',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {}
